const validator = require('../../../../../components/textfield/validator.min')
const textfieldHandler = require('../../../../../components/textfield/textfield-handler')
const settings = require('../../../../../js-handler/settings')
const scrim = require('../../../../../components/scrim/scrim')
const dashboardSnack = require('./dashboard-snack')

let selectedEntityEmail = ''
let sending = false

const getEl = (id) => document.getElementById(id)
const show = (id, visible) => getEl(id)?.classList.toggle('dn', !visible)

function emailWrapper() {
  return getEl('reportHub_form_email')
}

function emailInput() {
  return emailWrapper()?.querySelector('.elem')
}

function setEmail(value) {
  const wrapper = emailWrapper()
  if (!wrapper) return

  textfieldHandler.clean(wrapper)
  if (value) textfieldHandler.fill(wrapper, value)
}

function parseOtherField(detail) {
  try {
    return JSON.parse(detail?.ev?.target?.getAttribute('otherField') || '{}')
  } catch (e) {
    return {}
  }
}

export function configure(def) {
  const enabled = !!def && def.sendEmailEnabled !== false
  selectedEntityEmail = ''
  show('reportHub-send-email-option', enabled)
  resetControls()
}

export function reset() {
  selectedEntityEmail = ''
  show('reportHub-send-email-option', false)
  resetControls()
}

function resetControls() {
  const checkbox = getEl('reportHub_send_email')?.querySelector('input')
  if (checkbox) checkbox.checked = false
  setEmail('')
  show('reportHub-send-email-field', false)
  show('reportHub-generate-button', true)
  show('reportHub-send-email-button', false)
}

export function toggle() {
  const checked = !!getEl('reportHub_send_email')?.querySelector('input')?.checked
  show('reportHub-send-email-field', checked)
  show('reportHub-generate-button', !checked)
  show('reportHub-send-email-button', checked)
  if (checked) setEmail(selectedEntityEmail)
}

export function setSelectedEntity(detail) {
  const data = parseOtherField(detail)
  selectedEntityEmail = validator.isEmail(String(data.email || '').trim())
    ? String(data.email).trim()
    : ''

  if (getEl('reportHub_send_email')?.querySelector('input')?.checked) {
    setEmail(selectedEntityEmail)
  }
}

function appendFilter(formData, key, value) {
  if (value === undefined || value === null || value === '') return
  formData.append(`filters[${key}]`, typeof value === 'boolean' ? (value ? '1' : '0') : value)
}

export function send(def, filters) {
  if (sending || !def || def.sendEmailEnabled === false) return

  const wrapper = emailWrapper()
  const email = String(emailInput()?.value || '').trim()
  if (!email) {
    textfieldHandler.error(wrapper)
    dashboardSnack.start({ act: 'show', id: 'emailResult', text: 'Please, enter an email.' })
    return
  }
  if (!validator.isEmail(email)) {
    textfieldHandler.error(wrapper)
    dashboardSnack.start({ act: 'show', id: 'emailResult', text: 'Please, enter a valid email.' })
    return
  }

  const formData = new FormData()
  formData.append('type', 'sendreport')
  formData.append('entity', def.entity)
  formData.append('reportName', def.reportname || def.id)
  formData.append('email', email)
  formData.append('userId', settings.getData().id)
  Object.keys(filters || {}).forEach((key) => appendFilter(formData, key, filters[key]))

  sending = true
  scrim.showLoading()
  fetch('./server/php/send-emails/sendEmail.php', {
    method: 'POST',
    body: formData,
    credentials: 'same-origin'
  })
    .then((response) => response.json())
    .then((response) => {
      if (Number(response.code) === 200) {
        dashboardSnack.start({ act: 'show', id: 'emailResult', text: response.message || 'Report sent successfully.' })
      } else if (Number(response.code) === 404) {
        dashboardSnack.start({ act: 'show', id: 'emailResult', text: response.message || 'No data was found for this report.' })
      } else {
        dashboardSnack.start({ act: 'show', id: 'emailResult', text: response.message || 'The report could not be sent.' })
      }
    })
    .catch(() => dashboardSnack.start({ act: 'show', id: 'emailResult', text: 'The report could not be sent.' }))
    .finally(() => {
      sending = false
      scrim.hideLoading()
    })
}
